import { dashboardClient } from '@/api'
import { QueryClient, infiniteQueryOptions } from '@tanstack/react-query'

export interface PriceTemplatesInfiniteQueryParams {
  /** Q */
  q?: string
  /**
   * Limit
   * A limit on the number of objects to be returned
   * @exclusiveMin 1
   * @max 300
   * @default 10
   */
  limit?: number
}

export const getPriceTemplatesInfinityOptions = (
  companyId: string,
  gameId: string,
  { ...params }: PriceTemplatesInfiniteQueryParams = {},
) =>
  infiniteQueryOptions({
    queryKey: [gameId, 'sku-price-templates', params],
    queryFn: async ({ pageParam }) => {
      const { data } = await dashboardClient.v1.getPriceTemplates({
        companyId,
        gameId,
        limit: 100,
        ...params,
        starting_after: pageParam || undefined,
      })
      return data
    },
    initialPageParam: '',
    getNextPageParam: lastPage => {
      return lastPage.next_cursor || null
    },
    select: data => data.pages.flatMap(page => page.data),
  })

export const refetchPriceTemplates = async (queryClient: QueryClient, companyId: string, gameId: string) => {
  await queryClient.refetchQueries({ queryKey: getPriceTemplatesInfinityOptions(companyId, gameId).queryKey })
}
